import $ from 'jquery';
import { utils } from '../common/utils';

export class DonationStatus {
    private $statusbox: JQuery<HTMLElement>;

    constructor(element: HTMLElement | JQuery<HTMLElement>) {
        this.$statusbox = utils.isJquery(element) ? element : $(element);
    }

    get StatusElement(): HTMLElement {
        return this.$statusbox[0];
    }

    clear(): void {
        this.$statusbox.html('');
        this.$statusbox.hide();
    }

    setStatus(text: string): void {
        this.$statusbox.html(text);
        this.$statusbox.show();
    }
}
